import {createContext} from 'react'

const OperationsCenterContext = createContext({
    eventDetails: null,
    changeEventDetails: null,
    changeLayout: null,
    deleteWidget: null
})

export default OperationsCenterContext